import { render, staticRenderFns } from "./ToolbarTop.vue?vue&type=template&id=01452664&scoped=true"
import script from "./ToolbarTop.vue?vue&type=script&lang=js"
export * from "./ToolbarTop.vue?vue&type=script&lang=js"
import style0 from "./ToolbarTop.vue?vue&type=style&index=0&id=01452664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01452664",
  null
  
)

export default component.exports